export default __webpack_public_path__ + "static/media/Redirect.298cf0d3.svg";